const OfferModule = () => import('./OfferModule.vue')
const OfferIndex = () => import('./views/OfferIndex.vue')
const OfferActivations = () => import('./views/OfferActivationIndex.vue')

export const offerRoute = {
  name: 'offers',
  path: '/offers',
  component: OfferModule,
  meta: {
    title: 'Offers',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'offers-index',
      meta: {
        permission: 'offers.view',
      },
      component: OfferIndex,
    },
    {
      path: ':id/activations',
      name: 'offers-activations',
      meta: {
        permission: 'offers.view',
      },
      component: OfferActivations,
    },
  ],
}
